import { render, staticRenderFns } from "./main_culinarymobile.vue?vue&type=template&id=b2f1546e&"
import script from "./main_culinarymobile.vue?vue&type=script&lang=js&"
export * from "./main_culinarymobile.vue?vue&type=script&lang=js&"
import style0 from "./main_culinarymobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports